import React, { useEffect, useMemo, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import http from "../../../services/httpService";
import { Root } from "../ViewCd/styles";
import { Ptag } from "../../../components/fonts";
import GradeSummaryAccordion from "./GradeSummaryAccordian";
import GradeSummaryDetail from "./GradeSummaryDetail";
import backArrow from "../../../assets/images/arrowBack.png";
import { OverlayLoader } from "../../../components";
import styled from "styled-components";

function ViewGradeSetup() {
  const history = useHistory();
  const [isLoading, setLoader] = useState(false);
  const [grades, setGrades] = useState([]);
  const [isFlat, setIsFlat] = useState(false);
  const [productIdName, setProductIdName] = useState([]);
  const [reusableData, setReusableData] = useState()
  const { state } = useLocation();
  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        const { data } = await http.get("business/userplans_data_selected/");
        const userplan_id = state.state.useplanId;
        const gradeArray =
          data.userplans_data[userplan_id].userplan_grades_data;
        data &&
        data.userplans_data &&
        data.userplans_data[userplan_id] &&
        data.userplans_data[userplan_id].flat_or_graded == "FLAT"
          ? setIsFlat(true)
          : setIsFlat(false);
        setGrades(gradeArray);

        const response = await http.get(
          "/business/get_grade_setup_selectables/",
          {
            params: {
              userplan_id,
            },
          }
        );
        setReusableData(response.data)
        const product_id_name = response.data.map((value) => {
          const id = value.attribute_product_mapping_id;
          const name =
            value.attribute_data.attribute_ui_showables &&
            Object.keys(value.attribute_data.attribute_ui_showables)[0];
          return [id, name];
        });

        setProductIdName(product_id_name);
      } catch (error) {
        console.log(error);
      } finally {
        setLoader(false);
      }
    };

    fetchData(); // Call the async function inside useEffect

    // Cleanup function
    return () => {};
  }, []);

  const redirectToDashboard = () => {
    history.push("/business/dashboard");
  };

  return (
    <Root style={{ padding: "4rem" }}>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <div style={{ maxWidth: "900px" }}>
          <div
            style={{
              display: "flex",
              marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <img
              style={{
                marginRight: "10px",
                height: "2.5rem",
                width: "2.5rem",
                cursor: `${state ? "pointer" : ""}`,
              }}
              onClick={() => redirectToDashboard()}
              src={backArrow}
            />
            <Ptag fontSize="20px" fontWeight="bold">
              Plan Overview
            </Ptag>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {isFlat
              ? grades &&
                grades.map((value, index) => (
                  <div key={index}>
                    <FlatSummay>
                      <GradeSummaryDetail
                        gradeData={value}
                        isFlat={isFlat}
                        productIdName={productIdName}
                        state={state}
                        reusables={reusableData}
                      />
                    </FlatSummay>
                  </div>
                ))
              : grades &&
                grades.map((value, index) => (
                  <div key={index}>
                    <GradeSummaryAccordion
                      title={`Grade ${index + 1}`}
                      defaultExpanded={index === 0}
                    >
                      <GradeSummaryDetail
                        gradeData={value}
                        productIdName={productIdName}
                        state={state}
                        reusables={reusableData}
                      />
                    </GradeSummaryAccordion>
                  </div>
                ))}
          </div>
        </div>
      )}
    </Root>
  );
}

export default ViewGradeSetup;

const FlatSummay = styled.div`
  background-color: #f6f3ff;
  border-radius: 10px;
  max-width: 800px;
  padding: 32px 0 1px 32px;
`;
